import { render, staticRenderFns } from "./ThingsToNote.vue?vue&type=template&id=ab43a864&scoped=true&"
import script from "./ThingsToNote.vue?vue&type=script&lang=js&"
export * from "./ThingsToNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab43a864",
  null
  
)

export default component.exports